import { Col, Grid, Row, theme, Typography } from "antd";
import React from "react";

import { JobListing } from "./JobListing";
import { JobListingSkeleton } from "./JobListingSkeleton";
import {
  ColJobDepartment,
  ColJobLocation,
  ColJobTitle,
  ColTitle,
  SearchResultsContainer,
  SearchResultsDescription,
  SearchResultsTitle,
  ShowMoreButton,
} from "./styled";
import { SearchResultsProps } from "./types";

export const SearchResults: React.FC<SearchResultsProps> = ({
  title,
  description,
  jobs,
  metadata,
  isLoading,
  showMoreJobs,
}) => {
  const { token } = theme.useToken();
  const breakpoints = Grid.useBreakpoint();

  const isMobileDisplay = !breakpoints.lg;

  return (
    <SearchResultsContainer $isMobile={isMobileDisplay}>
      {!isLoading && jobs.length > 0 && (
        <>
          {title && (
            <Row>
              <Col span={24}>
                <SearchResultsTitle>{title}</SearchResultsTitle>
              </Col>
            </Row>
          )}

          {description && (
            <Row>
              <Col span={24}>
                <SearchResultsDescription>
                  {description}
                </SearchResultsDescription>
              </Col>
            </Row>
          )}
        </>
      )}

      {jobs.length > 0 && (
        <Row>
          <ColJobTitle
            $token={token}
            style={isMobileDisplay ? { padding: "0.75rem 0" } : {}}
          >
            <ColTitle>
              {isMobileDisplay
                ? `Jobs ${
                    metadata?.total?.toLocaleString()
                      ? `(${metadata?.total?.toLocaleString()})`
                      : ""
                  }`
                : "Role"}
            </ColTitle>
          </ColJobTitle>
          <ColJobDepartment>
            <ColTitle>{"Department"}</ColTitle>
          </ColJobDepartment>
          <ColJobLocation>
            <ColTitle>{"Location"}</ColTitle>
          </ColJobLocation>
        </Row>
      )}

      <React.Fragment>
        {jobs.length > 0 && (
          <React.Fragment>
            {jobs.map((job, idx) => (
              <JobListing
                key={idx}
                job={job}
                isMobileDisplay={isMobileDisplay}
                requestId={metadata?.request_id}
              />
            ))}
          </React.Fragment>
        )}

        {isLoading && <JobListingSkeleton />}

        <React.Fragment>
          {metadata?.nextPageToken && (
            <ShowMoreButton onClick={showMoreJobs} className="fadeInFast">
              {"Show more jobs"}
            </ShowMoreButton>
          )}

          {metadata && jobs.length > 0 && (
            <Typography.Text
              style={{ verticalAlign: "middle" }}
              className="fadeInFast"
            >
              {`Showing ${jobs.length.toLocaleString()} of ${metadata.total.toLocaleString()}`}
            </Typography.Text>
          )}
        </React.Fragment>
      </React.Fragment>
    </SearchResultsContainer>
  );
};
